module.exports = __webpack_public_path__ + "assets/img/play.00837336.svg";